import type { Brand } from '@pdcfrontendui/types';
import { startOfDay } from 'date-fns';

/**
 * Date that is guaranteed to be at the start of the day (exactly midnight).
 */
export type StartOfDay = Brand<Date, 'StartOfDay'>;

export const getStartOfDay = (date: Date): StartOfDay => startOfDay(date);

export const isStartOfDay = (date: Date): date is StartOfDay =>
  date.getHours() === 0 &&
  date.getMinutes() === 0 &&
  date.getSeconds() === 0 &&
  date.getMilliseconds() === 0;
